"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const js_joda_1 = require("js-joda");
require("js-joda-timezone");
const Either_1 = require("fp-ts/lib/Either");
const format_1 = require("./format");
const Ord_1 = require("fp-ts/lib/Ord");
exports.today = () => new LocalDate(js_joda_1.LocalDate.now(format_1.hki));
class LocalDate {
    constructor(d) {
        this.d = d;
        this.format = (fmt = 'fi') => this.d.format(format_1.localDateFormatterOf(fmt));
        this.plusDays = (toAdd) => new LocalDate(this.d.plusDays(toAdd));
        this.plusYears = (toAdd) => new LocalDate(this.d.plusYears(toAdd));
        this.isAfter = (x) => this.d.isAfter(x.d);
        this.isEqual = (x) => this.d.isEqual(x.d);
        this.isCurrentYear = () => this.d.year() === exports.today().d.year();
        this.isWithInRange = (start, end) => this.d.plusDays(1).isAfter(start.d) && this.d.minusDays(1).isBefore(end.d);
        this.toDate = () => new Date(this.d.atStartOfDay(format_1.hki).toInstant().toEpochMilli());
    }
}
LocalDate.fromDate = (date) => new LocalDate(js_joda_1.LocalDate.ofInstant(js_joda_1.Instant.ofEpochMilli(date.getTime()), format_1.hki));
LocalDate.parse = (x) => Either_1.tryCatch(() => new LocalDate(js_joda_1.LocalDate.parse(x)), () => x);
LocalDate.fromFormatted = (x, fmt = 'fi') => Either_1.tryCatch(() => new LocalDate(js_joda_1.LocalDate.parse(x, format_1.localDateFormatterOf(fmt))), () => x);
LocalDate.endOfNextYear = () => new LocalDate(exports.today().d.plusYears(1).withMonth(12).withDayOfMonth(31));
LocalDate.ordDesc = Ord_1.fromCompare((a, b) => a.d.isBefore(b.d) ? 1 : a.d.isAfter(b.d) ? -1 : 0);
LocalDate.ordAsc = Ord_1.fromCompare((a, b) => b.d.isBefore(a.d) ? 1 : b.d.isAfter(a.d) ? -1 : 0);
exports.LocalDate = LocalDate;
exports.endDateOfNextYear = LocalDate.endOfNextYear;
